import { convertToPicocuries } from "./convertToPicocuries";

export const getRadonValue = (measurementUnit, BqmValue) => {
    if (BqmValue) {
        switch (measurementUnit) {
            case 0:
                return convertToPicocuries(BqmValue);
            case 1:
                if (BqmValue === undefined || BqmValue === "") {
                    return BqmValue;
                } else {
                    return parseFloat(BqmValue.toFixed(0));
                }
            default:
                return null;
        }
    } else if (BqmValue === 0) {
        return 0;
    }

    return null;
};
